module.exports = __webpack_public_path__ + "img/news-right.d8f80ac5.png";